import { useWeb3React } from '@web3-react/core';
import { useContext, useEffect } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import { Tab, TabBody, TabContent, TabHeader, Tabs } from '../components/Tabs';
import { config } from '../config/config';
import { SupportedChains } from '../config/constants';
import CreateASpoolState from '../context/createASpool/CreateASpoolState';
import themeContext from '../context/theme/themeContext';
import { formatAmountWithSuffix } from '../helpers/formats';
import useTotalSpoolTvr from '../hooks/web3/general/useTotalSpoolTvr';
import ConnectWalletFallBack from '../layout/ConnectWalletFallback';
import Footer from '../layout/Footer/Footer';
import Navbar from '../layout/Header/Navbar';
import SpoolApp from '../pages/SpoolApp';
import CreateASpool from '../pages/SpoolApp/CreateASpool';
import JoinASpool from '../pages/SpoolApp/JoinASpool/JoinASpool';
import Vault from '../pages/Vault';
import Widgets from '../pages/Widgets';

export const appRoutes = [
    '/',
    '/create-a-spool',
    `/${config.urls.spoolPath}/:spoolAddress`,
];
export const vaultRoutes = [
    '/platform-summary',
    '/your-spools',
    '/staking',
    '/your-creator-fees',
    '/your-creator-fees/:spoolAddress',
    '/egov',
    '/dao-vesting',
];

const arbitrumHiddenRoutes = ['/platform-summary', '/staking', '/egov', '/dao-vesting'];

export const isActiveRoute = (currentPath: string, pathToCompare: string) => {
    if (
        currentPath === pathToCompare ||
        pathToCompare === '/staking' ||
        currentPath === '/staking'
    )
        return false;

    if (
        currentPath === pathToCompare ||
        pathToCompare === '/egov' ||
        currentPath === '/egov'
    )
        return false;

    if (vaultRoutes.includes(pathToCompare) && vaultRoutes.includes(currentPath)) {
        return true;
    }

    if (appRoutes.includes(pathToCompare) && appRoutes.includes(currentPath)) {
        return true;
    }

    if (appRoutes.includes(pathToCompare) || vaultRoutes.includes(pathToCompare))
        return false;
};

const Routes: React.FC = () => {
    const { theme } = useContext(themeContext);

    const { account, chainId } = useWeb3React();

    const { totalSpoolTvr } = useTotalSpoolTvr();

    const history = useHistory();

    useEffect(() => {
        if (
            chainId === SupportedChains.ARBITRUM_ONE &&
            arbitrumHiddenRoutes.includes(window.location.pathname)
        ) {
            history.push('/');
        }
    }, [chainId, history]);

    return (
        <Switch>
            <Route
                exact
                path='/widgets/:spoolWidget/:spoolAddress/:spoolWidgetStyling?'
                component={Widgets}
            />
            <Route
                path='*'
                render={() => (
                    <>
                        <Navbar />
                        <main className={theme}>
                            <div className='total-spool-tvr'>
                                <p>
                                    Total Spool TVR{' '}
                                    <span>
                                        ${formatAmountWithSuffix(totalSpoolTvr || 0)}
                                    </span>
                                </p>
                            </div>
                            <Switch>
                                <Route path={appRoutes} exact component={SpoolApp} />
                                <Route
                                    path='/create-a-spool-b3c2f7e5-fb18-46cf-9f67-0d96e21e7cf6'
                                    exact
                                    render={() => (
                                        <Tabs>
                                            <TabHeader>
                                                <Tab to='/'>Join a Spool</Tab>
                                                <Tab to='/create-a-spool-b3c2f7e5-fb18-46cf-9f67-0d96e21e7cf6'>
                                                    Create a Spool
                                                </Tab>
                                            </TabHeader>
                                            <TabBody>
                                                <TabContent
                                                    to={[
                                                        '/',
                                                        `/${config.urls.spoolPath}`,
                                                    ]}
                                                >
                                                    <JoinASpool />
                                                </TabContent>
                                                <TabContent to='/create-a-spool-b3c2f7e5-fb18-46cf-9f67-0d96e21e7cf6'>
                                                    <CreateASpoolState>
                                                        <CreateASpool />
                                                    </CreateASpoolState>
                                                </TabContent>
                                            </TabBody>
                                        </Tabs>
                                    )}
                                />
                                <Route
                                    path={vaultRoutes}
                                    exact
                                    component={account ? Vault : ConnectWalletFallBack}
                                />
                                <Redirect to='/' />
                            </Switch>
                        </main>
                        <Footer />
                    </>
                )}
            />
        </Switch>
    );
};

export default Routes;
